import { isUserLoggedIn } from '../../utils/authUtils';
import { getPartialModel } from '../../utils/modelUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import { PagedResultRequestDto } from '../base/pagedResultRequestDto';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { ReferralContestDto } from './dto/referralContestDto';

export class ReferralContestService extends CrudServiceBase<ReferralContestDto> {
    constructor() {
        super(Endpoint.ReferralContest);
        this.internalHttp = httpApi;
    }

    public async create(createReferralContestInput: ReferralContestDto) {
        isUserLoggedIn();

        let newCreateReferralContestInput = getPartialModel(createReferralContestInput, [], ['id', 'creationTime', 'creatorUserId', 'lastModificationTime', 'lastModifierUserId']);

        let result = await this.internalHttp.post(this.endpoint.Create(), newCreateReferralContestInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async update(updateReferralContestInput: ReferralContestDto) {
        isUserLoggedIn();
        
        let newUpdateReferralContestInput = getPartialModel(updateReferralContestInput, [], ['creationTime', 'creatorUserId', 'lastModificationTime', 'lastModifierUserId']);

        let result = await this.internalHttp.put(this.endpoint.Update(), newUpdateReferralContestInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async getParticipants(contestId: number, pagedFilterAndSortedRequest: PagedResultRequestDto = this.defaultRequest, onlyEligible: boolean) {
        isUserLoggedIn();
        let result = await this.internalHttp.get(this.endpoint.Custom(`GetParticipants`), { params: {contestId: contestId, ...pagedFilterAndSortedRequest, onlyEligible} });
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }
}

const exportReferralContestService: ReferralContestService = new ReferralContestService();
export default exportReferralContestService;